// extracted by mini-css-extract-plugin
module.exports = {"hidden-nav":"hidden-nav___devsite","mds-section":"mds-section___devsite","navigable-section":"navigable-section___devsite"};